export default {
  title: 'Allergens',
  options: {
    dairy: 'Dairy/Milk',
    eggs: 'Eggs',
    fish: 'Fish',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Peanuts',
    sesame: 'Sesame',
    shellfish: 'Shellfish',
    soy: 'Soy',
    tree_nuts: 'Tree Nuts',
    celery: 'Celery',
    crustaceans: 'Crustaceans',
    lupin: 'Lupin',
    molluscs: 'Molluscs',
    mustard: 'Mustard',
    nuts: 'Nuts',
    sulphites: 'Sulphites',
    almonds: 'Almonds',
    barley: 'Barley',
    brazil_nuts: 'Brazil Nuts',
    cashew: 'Cashews',
    hazelnuts: 'Hazelnuts',
    kamut: 'Kamut',
    macadamia: 'Macadamia Nuts',
    oats: 'Oats',
    pecan: 'Pecans',
    pistachios: 'Pistachios',
    rye: 'Rye',
    spelt: 'Spelt',
    walnuts: 'Walnuts',
    wheat: 'Wheat',
    sugared_drink: 'Sugared Drink',
    lentils: 'Lentils',
    queensland_nuts: 'Queensland Nuts',
  },
};
